const ConditionalWrap = ({
  condition,
  wrapper,
  children
}) => condition ? wrapper(children) : children;

export { ConditionalWrap };
